const PaymentsTitle = () =>
  <p className="mb-3">
    <span className="fw-bold">Base Rent Schedule</span>
    <span className="ms-1 text-italic">(excludes addons, taxes & fees)</span>
  </p>

export default PaymentsTitle
